/*
 * @Description:
 * @Author: liuzhonghui
 * @Date: 2025-05-13 10:22:48
 * @LastEditTime: 2025-05-13 10:22:48
 * @LastEditors: liuzhonghui
 */
import Layout from '@/layout';
import { getShippersUrl } from '@/utils/shippers';

const waybillRouter = {
  path: `/intellRecord`,
  component: Layout,
  redirect: `/intellRecord`,
  alwaysShow: true, // will always show the root menu
  name: 'intellRecord',
  meta: {
    id: 3,
    title: '智能录单',
    icon: 'yzs_wanghuo',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
  },
  children: [
    {
      path: 'waybillAI',
      component: () => import('@/views/intellRecord/waybillAI/index'),
      name: 'waybillAI',
      meta: {
        id: 22,
        title: '智能录单',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: getShippersUrl('intellRecord/selfVehicle'),
      component: () => import('@/views/intellRecord/selfVehicle/index'),
      name: 'selfVehicle',
      meta: {
        id: 22,
        title: '自营车辆',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: getShippersUrl('intellRecord/set'),
      component: () => import('@/views/intellRecord/set/index'),
      name: 'set',
      meta: {
        id: 22,
        title: '录单配置',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: getShippersUrl('intellRecord/waybillData'),
      component: () => import('@/views/intellRecord/waybillData/index'),
      name: 'waybillData',
      meta: {
        id: 23,
        title: '运单数据',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
  ],
};
export default waybillRouter;
